import { defineMessages } from 'react-intl-next';

export default defineMessages({
	usingCodeReviewerTitle: {
		id: 'dev-agents.app.settings.code-reviewer.using-code-reviewer.title',
		defaultMessage: 'Using Code Reviewer',
		description: 'Title of the section explaining how to use Code Reviewer',
	},
	usingCodeReviewerIntro: {
		id: 'dev-agents.app.settings.code-reviewer.using-code-reviewer.intro',
		defaultMessage: 'Here are some key things to know about Code Reviewer.',
		description: 'Introduction text for the Code Reviewer usage section',
	},
	usingCodeReviewerReadMore: {
		id: 'dev-agents.app.settings.code-reviewer.using-code-reviewer.read-more',
		defaultMessage: 'Read more about Code Reviewer.',
		description: 'Link text to read more about Code Reviewer',
	},
	usingCodeReviewerLimitInfo: {
		id: 'dev-agents.app.settings.code-reviewer.using-code-reviewer.limit-info',
		defaultMessage:
			'Code Reviewer can review around 10 pull requests per hour in this workspace (depending on system resources). If you go over the limit, the agent will stop reviewing pull requests for about an hour.',
		description: 'Information about Code Reviewer rate limits',
	},
	usingCodeReviewerLanguagesInfo: {
		id: 'dev-agents.app.settings.code-reviewer.using-code-reviewer.languages-info',
		defaultMessage:
			'We currently support 10 popular languages, including Java, Javascript, Python, C++, and Go.',
		description: 'Information about supported programming languages',
	},
	usingCodeReviewerLanguagesLink: {
		id: 'dev-agents.app.settings.code-reviewer.using-code-reviewer.languages-link',
		defaultMessage: 'View the full list of supported languages',
		description: 'Link text to view all supported languages',
	},
	reviewPullRequestsToggleLabel: {
		id: 'dev-agents.app.settings.code-reviewer.repository-settings.review-prs-toggle-label',
		defaultMessage: 'Review pull requests in this repository',
		description: 'Label for the toggle to enable/disable Code Reviewer for a repository',
	},
	reviewPullRequestsTooltip: {
		id: 'dev-agents.app.settings.code-reviewer.repository-settings.review-prs-tooltip',
		defaultMessage:
			'When enabled, Code Reviewer will automatically check for code improvements and comment on pull requests in this repository.',
		description: 'Tooltip explaining what happens when Code Reviewer is enabled for a repository',
	},
	reviewPullRequestsTooltipLabel: {
		id: 'dev-agents.app.settings.code-reviewer.repository-settings.review-prs-tooltip-label',
		defaultMessage: 'Enable Code Reviewer for this repository',
		description: 'Accessibility label for the Code Reviewer toggle tooltip',
	},
	acceptanceCriteriaTitle: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.title',
		defaultMessage: 'Acceptance criteria check',
		description: 'Title for the acceptance criteria check section',
	},
	acceptanceCriteriaToggleLabel: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.toggle-label',
		defaultMessage: 'Check if pull requests match acceptance criteria',
		description: 'Label for the toggle to enable/disable acceptance criteria checking',
	},
	acceptanceCriteriaTooltip: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.tooltip',
		defaultMessage:
			'When enabled, Code Reviewer will check that code changes meet the acceptance criteria defined in the Jira issue.',
		description: 'Tooltip explaining what happens when acceptance criteria checking is enabled',
	},
	acceptanceCriteriaTooltipLabel: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.tooltip-label',
		defaultMessage: 'Check changes meet acceptance criteria',
		description: 'Accessibility label for the acceptance criteria toggle tooltip',
	},
	acceptanceCriteriaTimingTitle: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.timing-title',
		defaultMessage: 'When should acceptance criteria be checked?',
		description: 'Title for the section to choose when acceptance criteria should be checked',
	},
	acceptanceCriteriaCheckEveryCommit: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.check-every-commit',
		defaultMessage: 'Check after every new commit',
		description: 'Option to check acceptance criteria after every commit',
	},
	acceptanceCriteriaCheckOnPRCreation: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.check-on-pr-creation',
		defaultMessage: 'Check only when pull request is created',
		description: 'Option to check acceptance criteria only when a PR is created',
	},
	errorUpdateACSettings: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.error-update-settings',
		defaultMessage:
			"Something went wrong and we couldn't update acceptance criteria check settings for this repository, try again",
		description: 'Error message shown when updating acceptance criteria settings fails',
	},
	errorUpdateCommitCheck: {
		id: 'dev-agents.app.settings.code-reviewer.acceptance-criteria.error-update-commit-check',
		defaultMessage:
			"Something went wrong and we couldn't update commit check settings for this repository, try again",
		description: 'Error message shown when updating commit check settings fails',
	},
	errorUpdateCodeReviewerSettings: {
		id: 'dev-agents.app.settings.code-reviewer.settings.error-update-settings',
		defaultMessage:
			"Something went wrong and we couldn't update Code Reviewer settings for this repository, try again.",
		description: 'Error message shown when updating Code Reviewer settings fails',
	},
});
